import { render } from "./Edit.vue?vue&type=template&id=0095d518"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0095d518"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0095d518', __exports__)) {
    api.reload('0095d518', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=0095d518", () => {
    api.rerender('0095d518', render)
  })

}


export default __exports__